module.exports = __webpack_public_path__ + "static/media/star-blank.1b2f15eb.svg";